import * as Blockly from "blockly";

/**
 * ZRMS17 Blockly Blocks
 *
 * Modern ES module / React-compatible version.
 */

/* -----------------------------------------------------------
 * Helper
 * --------------------------------------------------------- */

const requireInFunction = Blockly.Blocks.requireInFunction;


/* ===========================================================
 * SPS / ZONE
 * ========================================================= */

Blockly.Blocks["zrms17_dropSPSBool"] = {
    init() {
        this.appendDummyInput()
            .setAlign(Blockly.inputs.Align.CENTER)
            .appendField("get Num Geysers");

        this.setInputsInline(true);
        this.setOutput(true, "Number");
        this.setColour(290);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_getNumSPSHeld"] = {
    init() {
        this.appendDummyInput()
            .appendField("get ")
            .appendField(
                new Blockly.FieldDropdown([
                    ["my", "0"],
                    ["other", "1"]
                ]),
                "playerID"
            )
            .appendField("score");

        this.setInputsInline(true);
        this.setOutput(true, "number");
        this.setColour(290);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_getZone"] = {
    init() {
        this.appendDummyInput()
            .appendField("get zone");

        this.appendValueInput("zoneInfo")
            .appendField("zoneInfo")
            .setCheck("array");

        this.setInputsInline(true);
        this.setOutput(true, "number");
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


/* ===========================================================
 * DOCK / DROP
 * ========================================================= */

Blockly.Blocks["zrms17_dockItem"] = {
    init() {
        this.appendDummyInput()
            .appendField("dock with item");

        this.setInputsInline(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setPreviousStatement(true);
        this.setNextStatement(true);

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_dockItemID"] = {
    init() {
        this.appendDummyInput()
            .appendField("dock with")
            .appendField(
                new Blockly.FieldDropdown([
                    ["Item 0", "0"],
                    ["Item 1", "1"],
                    ["Item 2", "2"],
                    ["Item 3", "3"],
                    ["Item 4", "4"],
                    ["Item 5", "5"]
                ]),
                "itemID"
            );

        this.setOutput(true, "number");
        this.setInputsInline(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_dockItemIDVoid"] = {
    init() {
        this.appendDummyInput()
            .appendField("dock with")
            .appendField(
                new Blockly.FieldDropdown([
                    ["Item 0", "0"],
                    ["Item 1", "1"],
                    ["Item 2", "2"],
                    ["Item 3", "3"],
                    ["Item 4", "4"],
                    ["Item 5", "5"]
                ]),
                "itemID"
            );

        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setInputsInline(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_dropSPSVoid"] = {
    init() {
        this.appendDummyInput()
            .appendField("drop SPS");

        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_dropItem"] = {
    init() {
        this.appendDummyInput()
            .appendField("drop current item");

        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


/* ===========================================================
 * ITEM INFO
 * ========================================================= */

Blockly.Blocks["zrms17_getItemLoc"] = {
    init() {
        this.appendDummyInput()
            .appendField("get location of ")
            .appendField(
                new Blockly.FieldDropdown([
                    ["Item 0", "0"],
                    ["Item 1", "1"],
                    ["Item 2", "2"],
                    ["Item 3", "3"],
                    ["Item 4", "4"],
                    ["Item 5", "5"]
                ]),
                "itemID"
            )
            .appendField(" into ");

        this.appendValueInput("pos")
            .appendField("pos")
            .setCheck("array");

        this.setPreviousStatement(true);
        this.setNextStatement(true);
        this.setInputsInline(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_itemInZone"] = {
    init() {
        this.appendDummyInput()
            .appendField("is item")
            .appendField(
                new Blockly.FieldDropdown([
                    ["Item 0", "0"],
                    ["Item 1", "1"],
                    ["Item 2", "2"],
                    ["Item 3", "3"],
                    ["Item 4", "4"],
                    ["Item 5", "5"]
                ]),
                "itemID"
            )
            .appendField("in zone");

        this.setInputsInline(true);
        this.setOutput(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_hasItem"] = {
    init() {
        this.appendDummyInput()
            .appendField("has item")
            .appendField(
                new Blockly.FieldDropdown([
                    ["Item 0", "0"],
                    ["Item 1", "1"],
                    ["Item 2", "2"],
                    ["Item 3", "3"],
                    ["Item 4", "4"],
                    ["Item 5", "5"]
                ]),
                "itemID"
            );

        this.setInputsInline(true);
        this.setOutput(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_checkHaveItem"] = {
    init() {
        this.appendDummyInput()
            .appendField("check have")
            .appendField(
                new Blockly.FieldDropdown([
                    ["item 0", "0"],
                    ["item 1", "1"],
                    ["item 2", "2"],
                    ["item 3", "3"],
                    ["item 4", "4"],
                    ["item 5", "5"]
                ]),
                "itemID"
            )
            .appendField(
                new Blockly.FieldDropdown([
                    ["me", "1"],
                    ["other", "2"],
                    ["no-one", "0"]
                ]),
                "playerID"
            );

        this.setInputsInline(true);
        this.setOutput(true);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_isFacingCorrectItemSide"] = {
    init() {
        this.appendDummyInput()
            .appendField("is facing correct side of")
            .appendField(
                new Blockly.FieldDropdown([
                    ["Item 0", "0"],
                    ["Item 1", "1"],
                    ["Item 2", "2"],
                    ["Item 3", "3"],
                    ["Item 4", "4"],
                    ["Item 5", "5"]
                ]),
                "itemID"
            );

        this.setInputsInline(true);
        this.setOutput(true, "number");
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


/* ===========================================================
 * OTHER
 * ========================================================= */

Blockly.Blocks["zrms17_getScore"] = {
    init() {
        this.appendDummyInput()
            .appendField("get ")
            .appendField(
                new Blockly.FieldDropdown([
                    ["my", "0"],
                    ["other", "1"]
                ]),
                "playerID"
            )
            .appendField("score");

        this.setInputsInline(true);
        this.setOutput(true, "number");
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};


Blockly.Blocks["zrms17_getFuelRemaining"] = {
    init() {
        this.appendDummyInput()
            .appendField("get remaining fuel");

        this.setInputsInline(true);
        this.setOutput(true, null);
        this.setColour(20);
        this.setTooltip("");
        this.setHelpUrl("");

        this.setOnChange(requireInFunction);
    }
};